import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
// import { Link } from 'react-router-dom';
import StarRating from "./StarRating";
import { RatingGivenDetails } from "../../../actions/auth";
import { useDispatch } from "react-redux";
import { MY_PROFILE } from "../../../actions/types";
const GivenRatingDetails = (props) => {
  const dispatch = useDispatch();
  const [givenRatingData, setGivenRating] = useState({});
  const [pimage, setPImage] = useState("");
  const [fname, setfname] = useState("");
  useEffect(() => {
    dispatch(RatingGivenDetails(props.match.params.id)).then((res) => {
      if (res.success) {
        console.log(res.data);
        console.log(res.data.ratingGivenTo.profile_image);
        setPImage(res.data.ratingGivenTo.profile_image[0]);
        setfname(res.data.ratingGivenTo.firstname);
        setGivenRating(res.data);
        // console.log(localStorage.getItem('token'))
      }
    });
  }, []);
  return (
    <div id="wrapper">
      <Sidebar />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content-wrap">
          <Header />
          <div className="rating-details-content">
            <div className="container-fluid">
              <h1 class="events-heading mb-3">Given Rating Details</h1>
              <div className="row RatingDetailsBg">
                <div className="col-lg-7 col-sm-7 col-sm-12 col-12">
                  <div className="Ratings-detailss">
                    <div className="d-flex align-items-center">
                      <StarRating val={givenRatingData.question_two_answer} />

                      {/* <div>
                                                        <p className="reviews--text mb-0">4.2 based on 15 reviews</p>
                                                        </div> */}
                    </div>
                    <p className="RatingText">
                      Are the pictures accurate to what they looked like in
                      person?
                    </p>
                  </div>
                  <div className="Ratings-detailss">
                    <div className="d-flex align-items-center">
                      <StarRating val={givenRatingData.question_three_answer} />

                      {/* <div>
                                                        <p className="reviews--text mb-0">4.2 based on 15 reviews</p>
                                                        </div> */}
                    </div>
                    <p className="RatingText">
                      Do you think they were accurate about their age?
                    </p>
                  </div>

                  <div className="Ratings-detailss">
                    <div className="d-flex align-items-center">
                      <StarRating val={givenRatingData.question_four_answer} />

                      {/* <div>
                                                        <p className="reviews--text mb-0">3.1 based on 15 reviews</p>
                                                        </div> */}
                    </div>
                    <p className="RatingText">
                      Do you feel they were accurate about their height?
                    </p>
                  </div>

                  <div className="Ratings-detailss">
                    <div className="d-flex align-items-center">
                      <StarRating val={givenRatingData.question_five_answer} />

                      {/* <div>
                                                        <p className="reviews--text mb-0">3.1 based on 15 reviews</p>
                                                        </div> */}
                    </div>
                    <p className="RatingText">
                      Do you think they are accurate about their lifestyle
                      selections?
                    </p>
                  </div>

                  <div class="row">
                    <div className="col-lg-5 col-sm-5 col-md-5 col-12 mt-4">
                      <label className="notes--text">Private Note</label>
                      <textarea
                        className="form-control"
                        placeholder=""
                        value={givenRatingData.question_seven_answer}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-sm-12 col-12">
                  <div className="profile--image">
                    <img
                      src={`${MY_PROFILE}/${
                        pimage ? pimage : "img/noImage.png"
                      }`}
                      alt="profile-img"
                      className="eventsProfile"
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                        e.target.src = "img/noImage.png"; // Fallback image if loading fails
                      }}
                    ></img>
                    <h3 className="rating-heading">From: {fname}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GivenRatingDetails;
